<template>
  <div>
    <div class="container">
      <div class="truck-description">{{ truck.description }}</div>
      <div class="row">
        <div class="col selector">
          <v-flex>
            <v-text-field
              id="scanner"
              v-model="barcode"
              box
              :label="$t('pallet_scanner.barcode')"
              autofocus
              @keyup.enter="performScan"
            ></v-text-field>
          </v-flex>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="console">
            <div id="console" class="panel-scrollable">
              <p v-for="(log, index) in logs" :key="index">
                <span :style="log.style">{{ log.text }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <truck-top
            v-if="truckLoaded"
            :truck="truck"
            :orders="orders"
            :divider="truckDivider"
            :hideWarning="true"
          />
        </div>
      </div>
    </div>
    <div class="confirm-dispatch">
      <v-btn color="info" v-if="truckLoadAvailable" @click="confirmTruck()">{{
        $t("truck_scanner.confirm_truck_dispatch")
      }}</v-btn>
    </div>
  </div>
</template>

<script>
import TruckTop from "../trucks/TruckTop.vue";
import Truck from "@/models/Truck.js";
import Pallet from "@/models/Pallet.js";
export default {
  name: "truck-scanner",
  props: ["truckId"],
  data() {
    return {
      truckLoaded: false,
      truck: {},
      barcode: "",
      logs: [],
      orders: [],
      loadedBarcodes: [],
      truckLoadAvailable: false,
      truckDivider: 16
    };
  },
  mounted() {
    this.initialize();
  },
  watch: {
    truck: {
      handler(val) {
        let loadedCount = 0;
        val.pallets.forEach(pallet => {
          if (pallet.status >= 3) {
            loadedCount++;
          }
        });
        if (loadedCount == val.pallets.length) {
          this.truckLoadAvailable = true;
        }
      },
      deep: true
    }
  },
  methods: {
    async initialize() {
      this.truck = await Truck.loadTruck(this.truckId);
      this.getLoadedBarcodes();
    },
    async confirmTruck() {
      this.truckLoadAvailable = false;
      this.truck.status = 4;
      await this.truck.save();
      alert(this.$t("truck_scanner.truck_dispatched"));
    },
    async performScan() {
      //search in truck
      const foundInTruck = this.truck.pallets.find(e => {
        return e.number == this.barcode;
      });
      if (!foundInTruck) {
        this.logs.unshift({
          style: { color: "red" },
          text: `${this.$t("truck_scanner.pallet_with_barcode")}: ${
            this.barcode
          } - ${this.$t("truck_scanner.not_found")}`
        });
        this.barcode = "";
        return 0;
      }
      //search if already loaded
      const foundInLoaded = this.loadedBarcodes.find(e => {
        return e == this.barcode;
      });
      if (foundInLoaded) {
        this.logs.unshift({
          style: { color: "rgb(251, 140, 0)" },
          text: `${this.$t("truck_scanner.pallet_with_barcode")}: ${
            this.barcode
          } - ${this.$t("truck_scanner.already_loaded")}`
        });
        this.barcode = "";
        return 1;
      }

      if (foundInTruck.status < 2) {
        this.logs.unshift({
          style: { color: "red" },
          text: `${this.$t("truck_scanner.pallet_with_barcode")}: ${
            this.barcode
          } - ${this.$t("truck_scanner.not_ready")}`
        });
        this.barcode = "";
        return 2;
      }

      foundInTruck.status = 3;
      //update status
      await Pallet.updateByBarcode(this.barcode, {
        status: 3
      });
      this.logs.unshift({
        style: { color: "green" },
        text: `${this.$t(
          "truck_scanner.pallet_with_barcode"
        )}: ${this.barcode.slice(
          this.barcode.length - 4,
          this.barcode.length
        )} - ${this.$t("truck_scanner.successfully_loaded")}`
      });
      this.loadedBarcodes.push(this.barcode);
      this.barcode = "";
    },

    getTruckDivider() {
      let divider = 16;
      const truckLength = this.truck.getLength();
      while (truckLength / divider > (window.innerWidth * 7) / 10) {
        divider++;
      }
      this.truckDivider = divider;
    },

    getLoadedBarcodes() {
      let loaded = [];
      let orders = [];
      this.truck.pallets.forEach(pallet => {
        if (pallet.status >= 3) {
          loaded.push(pallet.number);
        }
        pallet.products.forEach(product => {
          if (!orders.includes(product.order)) {
            orders.push(product.order);
          }
        });
      });
      this.orders = orders;
      this.loadedBarcodes = loaded;
      this.getTruckDivider();
      this.truckLoaded = true;
    }
  },
  components: {
    TruckTop
  }
};
</script>

<style scoped>
.console {
  position: relative;
  width: 100%;
  height: 15em;
  overflow: hidden;
  background-color: rgba(87, 88, 86, 0.11);
}
.panel-scrollable {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding-right: 10%;
  box-sizing: content-box;
}
.truck-description {
  margin-left: 2px;
  font-size: 24px;
  font-weight: bold;
}
.confirm-dispatch {
  text-align: center;
  vertical-align: middle;
}
</style>
